import React from 'react';
import { bool, oneOf, string } from 'prop-types';
import { isOutletSku, isRetiredDesignSku } from '../../hooks/utils';
import InfoIcon from '../Common/Icons/infoIcon';
import classes from './outletTags.module.css';
/**
 * One line of copy per tag, shown in the PDP info tooltip next to the tags. It is the same copy
 * as the Outlet landing category blocks. The info icon only renders for tags that have copy here,
 * so it stays hidden until the copy is filled in.
 */

export var OUTLET_TAG_COPY = {
  OUTLET: '',
  'RETIRED DESIGN': '',
  'FINAL CALL': ''
}; // OUTLET for OUT- products, RETIRED DESIGN for DIS- products, and FINAL CALL (hf_hot_deal) always
// after one of them, never on its own. Non-outlet SKUs get no tags.

export var getOutletTagLabels = function getOutletTagLabels(sku, isFinalCall) {
  if (!isOutletSku(sku)) return [];
  var labels = [isRetiredDesignSku(sku) ? 'RETIRED DESIGN' : 'OUTLET'];
  if (isFinalCall) labels.push('FINAL CALL');
  return labels;
};
/**
 * HBF-145 outlet product tags (Figma "label new").
 *
 * @param {string} props.sku - product SKU, decides OUTLET vs RETIRED DESIGN
 * @param {boolean} props.isFinalCall - hf_hot_deal of the product
 * @param {string} props.variant - "card" (4px gap) or "pdp" (10px gap)
 * @param {string} props.className - extra classes for the wrapper
 */

var OutletTags = function OutletTags(_ref) {
  var sku = _ref.sku,
      isFinalCall = _ref.isFinalCall,
      variant = _ref.variant,
      className = _ref.className;
  var labels = getOutletTagLabels(sku, isFinalCall);
  if (!labels.length) return null;
  var rootClass = variant === 'pdp' ? classes.root_pdp : classes.root;
  var tags = React.createElement("div", {
    className: className ? "".concat(rootClass, " ").concat(className) : rootClass
  }, labels.map(function (label) {
    return React.createElement("span", {
      key: label,
      className: classes.tag
    }, label);
  }));
  if (variant !== 'pdp') return tags;
  var infoItems = labels.filter(function (label) {
    return OUTLET_TAG_COPY[label];
  });
  if (!infoItems.length) return tags;
  return React.createElement("div", {
    className: classes.pdpWrapper
  }, tags, React.createElement("span", {
    className: classes.info,
    tabIndex: 0,
    "aria-label": "About these tags"
  }, React.createElement(InfoIcon, null), React.createElement("span", {
    className: classes.infoContent,
    role: "tooltip"
  }, infoItems.map(function (label) {
    return React.createElement("span", {
      key: label,
      className: "block ".concat(classes.infoItem)
    }, React.createElement("span", {
      className: classes.infoLabel
    }, label, ": "), OUTLET_TAG_COPY[label]);
  }))));
};

OutletTags.propTypes = {
  sku: string,
  isFinalCall: bool,
  variant: oneOf(['card', 'pdp']),
  className: string
};
OutletTags.defaultProps = {
  isFinalCall: false,
  variant: 'card'
};
/**
 * A single FINAL CALL tag, used next to the price of a qualifying configuration on the Outlet PDP.
 */

export var FinalCallTag = function FinalCallTag(_ref2) {
  var className = _ref2.className;
  return React.createElement("span", {
    className: className ? "".concat(classes.tag, " ").concat(className) : classes.tag
  }, "FINAL CALL");
};
FinalCallTag.propTypes = {
  className: string
};
export default OutletTags;